import { Button, Col, Form, Row, Modal } from "../../ui/ot";
import React, { useEffect, lazy, Suspense, useState } from "react";
import { ArticleTable } from './ArticleManagement'
const ArticleSelectModal = ({
    axiosMode = "post",
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => { },
    onFinish = () => { },
    articleTableProps
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "修改",
    };
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectInfos, setSelectInfos] = useState(0);
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
        onSelectFinish(selectInfos)
    };

    const handleCancel = () => {
        closeModal();
    };
    const onSelectFinish = (values) => {
        onFinish(values);
    };
    useEffect(() => {
    }, [propsOpen]);
    return (
        <>
            {propsOpen === null && (
                <Button type="primary" onClick={showModal}>
                    {`${axiosModelanguage[axiosMode]}資料`}
                </Button>
            )}

            <Modal
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={'700px'}
                contentStyle={{
                    padding: 16
                }}
                okText={'儲存'}
                cancelText={'取消'}
            >
                <Row
                   
                    gutter={[8, 8]}
                >
                    <Col span={24}>
                    </Col>
                    <Col span={24}>
                        <ArticleTable
                            {...articleTableProps}
                            onSelectChange={(values) => {
                                setSelectInfos(values)
                            }}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default ArticleSelectModal;
